import account from './account';
import incentives from './incentives';
import personalized from './personalized';
import testParams from './testparams';

const root = {
	account,
	incentives,
	personalized,
	testParams
};

export default root;
